// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Drawer header & subtitle block ────────────────────────────────────── */

.J2GC9ubYaSTQhQCPEIUM {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    height: var(--curio-top-bar-height);
    padding: 10px 16px;
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    border-bottom: 1px solid var(--curio-top-bar-border);
    font-family: var(--curio-font-family);
}

.do9DxkoeuaFffqGiGeti {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid #444;
    border-radius: var(--curio-radius-sm);
    background: transparent;
    color: var(--curio-text-on-dark-muted);
    cursor: pointer;
}

.do9DxkoeuaFffqGiGeti:hover {
    background: rgba(255, 255, 255, 0.06);
    color: var(--curio-text-on-dark);
}

.IoeYZL6gLPwK8YX3IMAw {
    border-color: var(--curio-text-on-dark);
    background: rgba(255, 255, 255, 0.12);
    color: var(--curio-text-on-dark);
}

.HO0jkn63qMb2JXehgonT {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.C0WWEzM_oh9IxtBSvQtu {
    margin: 0;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    line-height: 1.2;
    color: var(--curio-text-on-dark);
}

/* Subtitle row */

.b9S6ctqz3DObDkCpddU1 {
    flex-shrink: 0;
    padding: 12px 16px;
    background: var(--curio-card-bg);
    border-bottom: 1px solid var(--curio-border);
    font-family: var(--curio-font-family);
}

.fe5oZBkp2IC4zYzbHl_X {
    margin: 0;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/DrawerHeader.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mCAAmC;IACnC,kBAAkB;IAClB,mCAAmC;IACnC,gCAAgC;IAChC,oDAAoD;IACpD,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,qCAAqC;IACrC,uBAAuB;IACvB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,iBAAiB;;AAEjB;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB","sourcesContent":["/* ── Drawer header & subtitle block ────────────────────────────────────── */\n\n.topBar {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    height: var(--curio-top-bar-height);\n    padding: 10px 16px;\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    border-bottom: 1px solid var(--curio-top-bar-border);\n    font-family: var(--curio-font-family);\n}\n\n.iconBtn {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: 1px solid #444;\n    border-radius: var(--curio-radius-sm);\n    background: transparent;\n    color: var(--curio-text-on-dark-muted);\n    cursor: pointer;\n}\n\n.iconBtn:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: var(--curio-text-on-dark);\n}\n\n.iconBtnActive {\n    border-color: var(--curio-text-on-dark);\n    background: rgba(255, 255, 255, 0.12);\n    color: var(--curio-text-on-dark);\n}\n\n.drawerTitleRow {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n\n.drawerTitle {\n    margin: 0;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    line-height: 1.2;\n    color: var(--curio-text-on-dark);\n}\n\n/* Subtitle row */\n\n.subtitleBlock {\n    flex-shrink: 0;\n    padding: 12px 16px;\n    background: var(--curio-card-bg);\n    border-bottom: 1px solid var(--curio-border);\n    font-family: var(--curio-font-family);\n}\n\n.subtitle {\n    margin: 0;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBar": `J2GC9ubYaSTQhQCPEIUM`,
	"iconBtn": `do9DxkoeuaFffqGiGeti`,
	"iconBtnActive": `IoeYZL6gLPwK8YX3IMAw`,
	"drawerTitleRow": `HO0jkn63qMb2JXehgonT`,
	"drawerTitle": `C0WWEzM_oh9IxtBSvQtu`,
	"subtitleBlock": `b9S6ctqz3DObDkCpddU1`,
	"subtitle": `fe5oZBkp2IC4zYzbHl_X`
};
export default ___CSS_LOADER_EXPORT___;
